import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getMyQuotation } from '../api/vendorApi';
import { VpSpinner, VpStatusBadge, money, fmtDate } from '../components/VpUI';

const VendorQuotationDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [q, setQ] = useState<any>(null);
	const [error, setError] = useState('');

	useEffect(() => {
		(async () => {
			try {
				const data = await getMyQuotation(id as string);
				setQ(data);
			} catch (err: any) {
				setError(err?.apiMessage || 'Could not load the quotation.');
			} finally {
				setLoading(false);
			}
		})();
	}, [id]);

	if (loading) return <VpSpinner />;
	if (error) return <div className='vp-alert vp-alert-error'>{error}</div>;

	const accepted = q?.quotation_status === 'confirmed';
	const products = q?.products || [];

	return (
		<div>
			{accepted && (
				<div className='vp-congrats'>
					<div className='vp-congrats-emoji'>🎉</div>
					<div>
						<h3>Congratulations! Your quotation was accepted.</h3>
						<p>
							You can now upload your challan(s) and invoice for this order from the
							Challans &amp; Invoices section.
						</p>
					</div>
				</div>
			)}

			<div className='vp-card vp-card-pad' style={{ marginBottom: 18 }}>
				<div className='vp-row-between'>
					<div>
						<div className='vp-muted' style={{ fontSize: 13 }}>
							Quotation
						</div>
						<div style={{ fontSize: 20, fontWeight: 700 }}>{q?.quotation_no}</div>
						<div className='vp-muted' style={{ fontSize: 13, marginTop: 4 }}>
							Requisition {q?.requisition?.requisition_no || '—'} ·{' '}
							{fmtDate(q?.quotation_date || q?.createdAt)}
						</div>
					</div>
					<div style={{ textAlign: 'right' }}>
						<VpStatusBadge status={q?.quotation_status} />
						{accepted && (
							<div style={{ marginTop: 10 }}>
								<button
									type='button'
									className='vp-btn vp-btn-primary vp-input-sm'
									onClick={() => navigate('/vendor-portal/challans')}>
									Upload Challan / Invoice
								</button>
							</div>
						)}
					</div>
				</div>
			</div>

			<div className='vp-card'>
				<div className='vp-card-head'>
					<h3>Quoted Items</h3>
					<span className='vp-badge vp-badge-neutral'>🔒 Locked after submit</span>
				</div>
				<div className='vp-table-wrap'>
					<table className='vp-table'>
						<thead>
							<tr>
								<th>Product</th>
								<th>Qty</th>
								<th>Rate</th>
								<th>Discount</th>
								<th>Tax %</th>
								<th style={{ textAlign: 'right' }}>Amount</th>
							</tr>
						</thead>
						<tbody>
							{products.map((p: any) => (
								<tr key={p._id}>
									<td style={{ fontWeight: 600 }}>
										{p.productInfo?.name || p.product_description || 'Item'}
									</td>
									<td>{p.quantity}</td>
									<td>{money(p.rate)}</td>
									<td>
										{p.discount || 0}
										{p.discountType === 'fixed' ? ' ₹' : ' %'}
									</td>
									<td>{p.tax || 0}%</td>
									<td style={{ textAlign: 'right', fontWeight: 600 }}>
										{money(p.amount_with_tax)}
									</td>
								</tr>
							))}
						</tbody>
						<tfoot>
							<tr>
								<td colSpan={5} style={{ textAlign: 'right', fontWeight: 700 }}>
									Total
								</td>
								<td style={{ textAlign: 'right', fontWeight: 800, fontSize: 16 }}>
									{money(q?.amount_total)}
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>

			{(q?.note || q?.remarks) && (
				<div className='vp-card vp-card-pad vp-mt-16'>
					{q?.note && (
						<div
							className='vp-field vp-mb-0'
							style={{ marginBottom: q?.remarks ? 16 : 0 }}>
							<label className='vp-label'>Note</label>
							<div>{q.note}</div>
						</div>
					)}
					{q?.remarks && (
						<div className='vp-field vp-mb-0'>
							<label className='vp-label'>Remarks</label>
							<div>{q.remarks}</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default VendorQuotationDetail;
